import {
  Component,
  OnDestroy,
  AfterViewInit,
  Output,
  EventEmitter,
  ElementRef,
} from "@angular/core";
import { LocationStrategy } from "@angular/common";

/**
 * Editor TinyMCE carregado sob demanda (fora do bundle global).
 */
@Component({
  selector: "ngx-tiny-mce",
  template: "",
})
export class TinyMCEComponent implements OnDestroy, AfterViewInit {
  @Output() editorKeyup = new EventEmitter<any>();

  editor: any;

  constructor(
    private host: ElementRef,
    private locationStrategy: LocationStrategy
  ) {}

  async ngAfterViewInit() {
    await import("tinymce/tinymce");
    await import("tinymce/themes/modern/theme");
    await import("tinymce/plugins/link/plugin");
    await import("tinymce/plugins/paste/plugin");
    await import("tinymce/plugins/table/plugin");

    const tinymce = (window as any).tinymce;
    if (!tinymce) {
      return;
    }
    tinymce.init({
      target: this.host.nativeElement,
      plugins: ["link", "paste", "table"],
      skin_url: `${this.locationStrategy.getBaseHref()}assets/skins/lightgray`,
      setup: (editor) => {
        this.editor = editor;
        editor.on("keyup", () => {
          this.editorKeyup.emit(editor.getContent());
        });
      },
      height: "320",
    });
  }

  ngOnDestroy() {
    const tinymce = (window as any).tinymce;
    if (tinymce && this.editor) {
      tinymce.remove(this.editor);
    }
  }
}
